import { useCallback } from "react";

import { TABLE_SETTINGS_APPLIED_MESSAGE } from "@/ds";
import type { ToastApi } from "@/ds";

/** Toast de sucesso de "Configurações da Tabela", com o texto único do DS; a tela só o chama ao aplicar. */
export function useTableSettingsAppliedToast(toast: ToastApi) {
  return useCallback(() => {
    toast.success("Sucesso", TABLE_SETTINGS_APPLIED_MESSAGE);
  }, [toast]);
}
